import React,{useState,useEffect,useRef}from 'react'
import { Modal,App,Form,Input, Radio,} from 'antd';
import GetUserDept from '../../cpn/GetUserDept';
import { useBnsGoodsUpdateQuery, useBnsGoodsUpdateSaveMutation } from '../../store/BnsKeJiApi';
import ProjectTypeSelect from './ProjectTypeSelect';
import {EditOutlined,} from '@ant-design/icons';
const {TextArea} = Input
function ProjectEdit(props) {
    const {message} = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [info,setInfo] = useState({
        bg_content:''
    }); 
    const {data,isSuccess} = useBnsGoodsUpdateQuery({bg_id:props.bg_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bg_name:data.Result.bg_name,
                    bg_dept_id:data.Result.bg_dept_id,
                    bg_content:data.Result.bg_content,
                    bg_type_id:data.Result.bg_type_id,
                    bg_state:data.Result.bg_state,
                })
                setInfo(prevState=>({...prevState,
                    bg_name:data.Result.bg_name,                  
                    bg_dept_id:data.Result.bg_dept_id,                  
                    bg_content:data.Result.bg_content,                  
                    bg_dept_name:data.Result.bg_dept_name,                  
                    bg_type_id:data.Result.bg_type_id,                  
                    bg_state:data.Result.bg_state,                  
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsGoodsUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined /> 修改项目</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改产品'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    goodsEdit({
                        "bg_e_id" : localStorage.getItem('e_id'),
                        "bg_id" : props.bg_id,
                        "bg_name" : info.bg_name,
                        "bg_content" : info.bg_content?info.bg_content:'',
                        "bg_dept_id" : info.bg_dept_id,
                        "bg_dept_name" : info.bg_dept_name,
                        "bg_type_id" : info.bg_type_id,
                        "bg_state" : info.bg_state,
                        "bg_uid" :localStorage.getItem('eu_id'),
                        "bg_uname" : localStorage.getItem('eu_name'),                                 
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}        
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.bg_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <GetUserDept
                        label='部门'
                        required
                        wrapperCol={{span:10}} 
                        getUserDept={(e,f) => {
                            setInfo(prevState=>({...prevState,bg_dept_id:e,bg_dept_name:f}))
                        }}
                        name='bg_dept_id'
                    />
                    <ProjectTypeSelect
                        label='项目类型'
                        required
                        wrapperCol={{span:10}} 
                        onChange={(e,f) => {
                            console.log(e);
                            setInfo(prevState=>({...prevState,bg_type_id:e}))
                        }}
                        name='bg_type_id'
                    />
                    <Form.Item name="bg_name" label='项目名称' wrapperCol={{span:10}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bg_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item name="bg_content" label='项目说明' wrapperCol={{span:20}}>
                        <TextArea 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bg_content:e.target.value}))}}
                            rows={5}
                        />
                    </Form.Item> 
                    <Form.Item name="bg_state" label='项目状态' wrapperCol={{span:20}}>
                        <Radio.Group onChange={(e) => {setInfo(prevState=>({...prevState,bg_state:e.target.value}))}}>
                            <Radio value='1'>开发中</Radio>
                            <Radio value='2'>使用中</Radio>
                            <Radio value='3'>已停用</Radio>
                        </Radio.Group>                       
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default ProjectEdit